import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const ColumnCategoryList = lazy(() => import('@/pages/columns-category/List'));
const ColumnCategoryCreate = lazy(() => import('@/pages/columns-category/Create'));
const ColumnCategoryEdit = lazy(() => import('@/pages/columns-category/Edit'));
const ColumnCategoryDetail = lazy(() => import('@/pages/columns-category/Detail'));

export const columnCategoryRoutes: RouteObject = {
  path: 'columns-category',
  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:columns-category:list">
          <SuspenseWrapper>
            <ColumnCategoryList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:columns-category:create">
          <SuspenseWrapper>
            <ColumnCategoryCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:columns-category:edit">
          <SuspenseWrapper>
            <ColumnCategoryEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:id',
      element: (
        <ProtectedRoute pageKey="page:columns-category:detail">
          <SuspenseWrapper>
            <ColumnCategoryDetail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};

